import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { CookieAccept_COOKIE, ToS_COOKIE} from '@global/GlobalFunctions';

/**
 * Default Class
 */
@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements AfterViewInit {

	public LoggingOutComplete: boolean = false;
	public WaitMessage: string = "Logging you Out of PRISMPdM - Please wait";

	/**
	 * Default Constructor
	 * @param auth Auth0 Login Details
	 * @param router Router
	 * @param siteSubscriptions Site Subscriptions
	 */
	constructor(
		public auth: AuthService,
		private router: Router,
		private siteSubscriptions: siteSubscriptions,
		private cookieService: CookieService,
	) { }

	/** ngAfterViewInit */
	async ngAfterViewInit(): Promise<void> {
		this.WaitMessage = "Logging you Out of PRISMPdM - Please wait";

		// Delay navigation for UX
		await new Promise(resolve => setTimeout(resolve, 2000));

		/** Clear Local Storage immediately */
		this.siteSubscriptions.ClearLocalStorage();

		/** Clear the Service Level Agreement Cookie */
		this.cookieService.delete(ToS_COOKIE, '/');

		/** Clear the cookieAcknowledged cookie */
		this.cookieService.delete(CookieAccept_COOKIE, '/');
		
		// Check Login Status
		const isAuthenticated = await firstValueFrom(this.auth.isAuthenticated$);

		// If Logged in then logout
		if (isAuthenticated) { this.auth.logout(); }

		// Show final message
		this.WaitMessage = "You have been logged out of the application";

		// Delay navigation for UX
		await new Promise(resolve => setTimeout(resolve, 2000));

		// Navigate to Root page
		this.router.navigate(['/']);
	}
}
